import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";
import CountUp from "react-countup";
import {
  Grid,
  Button,
  List,
  ListItem,
  Typography,
  CardMedia,
  CardContent,
} from "@material-ui/core";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MuiLink from "@mui/material/Link";

import Tooltip from "@mui/material/Tooltip";
import { withFormik } from "formik";
import * as Yup from "yup";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKBadge from "components/MKBadge";
import MKButton from "components/MKButton";
import MKAvatar from "components/MKAvatar";

import DataTable from "examples/Tables/DataTable";

// Images
import brandDark from "assets/images/logo-ct-dark.png";

import { getSinglePolicy } from "actions/policyActions";
import { getOrderSingle } from "actions/orderActions";
import { getSingleUser } from "actions/userActions";
import { claimPosting } from "actions/claimActions";

const ClaimReviewStep = (props) => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const [isSubmitting, setSubmitting] = useState(false);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [overallValues, setOverallValues] = useState({});
  console.log(
    "🚀 ~ file: index.js:15 ~ ClaimReviewStep ~ overallValues:",
    overallValues
  );

  const orderSingle = useSelector((state) => state.orderSingle);
  const { singleOrder } = orderSingle;

  const singleUser = useSelector((state) => state.singleUser);
  const { userSingle } = singleUser;

  const postClaim = useSelector((state) => state.postClaim);
  const { claimsPost, success, error } = postClaim;

  console.log("🚀 ~ file: index.js:57 ~ ClaimReviewStep ~ error:", error);
  console.log("🚀 ~ file: index.js:57 ~ ClaimReviewStep ~ success:", success);
  console.log(
    "🚀 ~ file: index.js:57 ~ ClaimReviewStep ~ claimsPost:",
    claimsPost
  );

  useEffect(() => {
    dispatch(getSingleUser());
  }, [dispatch, userSingle?.length]);

  useEffect(() => {
    dispatch(getOrderSingle(id));
  }, [dispatch, singleOrder?.length, id]);

  useEffect(() => {
    const localAddons = JSON.parse(localStorage.getItem("selectedAddons"));
    let currentAddons = singleOrder?.policy?.addons?.filter((item) =>
      localAddons?.some((addonItem) => addonItem?._id === item?._id)
    );
    setSelectedAddons(currentAddons);
  }, [dispatch, singleOrder?.policy?._id, id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    e.claim = claimsPost;
    setSubmitting(true);
    props?.handleSubmit();
    setSubmitting(false);
  };

  const handleSubmitClaim = () => {
    const myClaim = {
      order: singleOrder?._id,
      policy: overallValues?.policy?._id,
      client: overallValues?.personalDetails?._id,
      description: overallValues?.description,
      amount: 1,
      // addons: overallValues?.policy?.selectedAddons?.map((addon) => addon?._id),
      // computedAmount: getGrandTotal(),
      responseRequirements:
        overallValues?.requirements[0]?.responseRequirements,
      // startDate: overallValues?.period?.startDate,
      // endDate: overallValues?.period?.endDate,
    };
    console.log(
      "🚀 ~ file: index.js:98 ~ handleSubmitClaim ~ myClaim:",
      myClaim
    );
    dispatch(claimPosting(myClaim));
  };

  useEffect(() => {
    if (singleOrder?.policy) {
      var policyWithSelectedAddons = singleOrder?.policy;
      var updatedAddons = selectedAddons;
      policyWithSelectedAddons.selectedAddons = updatedAddons;
    }

    if (props?.values?.values) {
      var requirementsToArray = [];

      for (const key in props?.values?.values) {
        if (props?.values?.values.hasOwnProperty(key)) {
          const innerObject = props?.values?.values[key];
          requirementsToArray.push(innerObject);
        }
      }
    }

    setOverallValues({
      requirements: requirementsToArray,
      description: props?.values?.description,
      policy: singleOrder?.policy ? policyWithSelectedAddons : {},
      personalDetails: userSingle ? userSingle : {},
    });
  }, [
    singleOrder?._id,
    userSingle?._id,
    props?.values?.values?.length,
    selectedAddons?.length,
  ]);

  function renderRequirementsRows(data) {
    const values = [];
    data?.forEach((item, index) => {
      const newElement = {
        requestedItem: (
          <MKTypography
            key={index}
            variant="caption"
            color="text"
            fontWeight="medium"
          >
            {item?.claimRequirementTitle}
          </MKTypography>
        ),
        description: (
          <MKBox maxWidth={300}>
            <MKTypography variant="caption" color="text" fontWeight="medium">
              {item?.description}
            </MKTypography>
          </MKBox>
        ),
        type: (
          <MKTypography variant="caption" color="text" fontWeight="medium">
            {item?.claimRequirementType}
          </MKTypography>
        ),
        response: (
          <MKBox sx={{ whiteSpace: "normal" }}>
            <MKTypography variant="caption" color="text" fontWeight="medium">
              {item?.claimRequirementType === "file" &&
              item?.responseRequirement ? (
                <MKButton
                  component={MuiLink}
                  href={item?.responseRequirement}
                  target="_blank"
                  rel="noreferrer"
                  variant="text"
                  size="large"
                  color="dark"
                >
                  <Icon
                    fontSize="medium"
                    sx={{
                      fontWeight: "normal",
                      verticalAlign: "middle",
                    }}
                  >
                    document_scanner
                  </Icon>
                </MKButton>
              ) : item?.claimRequirementType === "image" &&
                item?.responseRequirement ? (
                <MKButton
                  component={MuiLink}
                  href={item?.responseRequirement}
                  target="_blank"
                  rel="noreferrer"
                  variant="text"
                  size="large"
                  color="dark"
                >
                  <Icon
                    fontSize="medium"
                    sx={{
                      fontWeight: "normal",
                      verticalAlign: "middle",
                    }}
                  >
                    image
                  </Icon>
                </MKButton>
              ) : (
                <>{item?.responseRequirement?.substring(0, 30) + "..."}</>
              )}
            </MKTypography>
            {/* <MKTypography
              variant="caption"
              color="text"
              textAlign="right"
              fontWeight="medium"
            >
              {item?.responseRequirement && (
                <Icon
                  fontSize="small"
                  sx={{
                    fontWeight: "normal",
                    verticalAlign: "middle",
                    marginLeft: 2,
                  }}
                >
                  check
                </Icon>
              )}
            </MKTypography> */}
          </MKBox>
        ),
      };
      if (item?.claimRequirementTitle) {
        values.push(newElement);
      }
    });
    return values;
  }

  return (
    <React.Fragment>
      <MKBox mt={6} mb={6}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12} md={12}>
            <Card>
              <MKBox p={5} lineHeight={0}>
                <MKBox display="flex" justifyContent="space-between">
                  <MKBox display="flex" alignItems="center">
                    <MKBox
                      component="img"
                      src={brandDark}
                      alt="Brand"
                      width="5rem"
                    />
                  </MKBox>

                  <MKBox display="flex" alignItems="center">
                    <MKBox
                      component="img"
                      src={singleOrder?.company?.companyLogo}
                      alt="Brand"
                      width="5rem"
                    />
                  </MKBox>
                </MKBox>

                <MKBox display="flex" justifyContent="space-between" mb={10}>
                  <MKBox>
                    <MKTypography variant="h6">Somosure Insurance</MKTypography>
                    <MKTypography variant="h6">Nairobi, Kenya</MKTypography>
                    <MKTypography variant="h6">
                      Email:{" "}
                      <MKTypography
                        variant="body"
                        fontSize="medium"
                        color="text"
                        fontWeight="regular"
                      >
                        somsure@mail.com
                      </MKTypography>
                    </MKTypography>
                    <MKTypography variant="h6">
                      Phone:{" "}
                      <MKTypography
                        variant="body"
                        fontSize="medium"
                        color="text"
                        fontWeight="regular"
                      >
                        +254 700 112344
                      </MKTypography>
                    </MKTypography>
                  </MKBox>

                  <MKBox textAlign="right">
                    <MKTypography variant="h6">
                      {singleOrder?.company?.companyName}
                    </MKTypography>
                    <MKTypography variant="h6">
                      {singleOrder?.company?.companyAddress}
                    </MKTypography>
                    <MKTypography variant="h6">
                      Email:{" "}
                      <MKTypography
                        variant="body"
                        fontSize="medium"
                        color="text"
                        fontWeight="regular"
                      >
                        {singleOrder?.company?.companyEmail}
                      </MKTypography>
                    </MKTypography>
                    <MKTypography variant="h6">
                      Phone:{" "}
                      <MKTypography
                        variant="body"
                        fontSize="medium"
                        color="text"
                        fontWeight="regular"
                      >
                        {singleOrder?.company?.companyPhone}
                      </MKTypography>
                    </MKTypography>
                  </MKBox>
                </MKBox>

                <MKBox display="flex" justifyContent="space-between" mb={5}>
                  <MKBox>
                    <MKTypography variant="h6">Policy No.</MKTypography>
                    <MKTypography
                      variant="button"
                      color="text"
                      fontWeight="regular"
                    >
                      #{overallValues?.policy?.policyNumber}
                    </MKTypography>
                    <MKTypography variant="h6" mt={1}>
                      Policy Name
                    </MKTypography>
                    <MKTypography
                      variant="button"
                      color="text"
                      fontWeight="regular"
                    >
                      {overallValues?.policy?.policyName}
                    </MKTypography>
                  </MKBox>

                  <MKBox textAlign="right">
                    {/* <MKTypography variant="h6">
                      Created:{" "}
                      <MKTypography
                        variant="button"
                        color="text"
                        fontWeight="regular"
                      >
                        {moment(overallValues?.policy?.created_at).format(
                          "DD/MM/YYYY"
                        )}
                      </MKTypography>
                    </MKTypography> */}
                    <MKTypography variant="h6">
                      Category:{" "}
                      <MKTypography
                        variant="body"
                        fontSize="medium"
                        color="text"
                        fontWeight="regular"
                      >
                        {singleOrder?.category?.mainCategory} -{" "}
                        {singleOrder?.category?.category}
                      </MKTypography>
                    </MKTypography>
                  </MKBox>
                </MKBox>

                <Grid container spacing={3} px={3}>
                  <Grid item xs={12} md={6} lg={6} sx={{ p: 1 }}>
                    <MKTypography variant="h6">Personal Details</MKTypography>
                  </Grid>
                </Grid>
                <MKBox p={3} mb={5}>
                  <DataTable
                    table={{
                      columns: [
                        {
                          Header: "Photo",
                          accessor: "photo",
                          width: "30%",
                          align: "left",
                        },
                        {
                          Header: "Name",
                          accessor: "name",
                          width: "30%",
                          align: "left",
                        },

                        {
                          Header: "Email",
                          accessor: "email",
                          width: "20%",
                          align: "center",
                        },
                        {
                          Header: "Phone",
                          accessor: "phone",
                          width: "10%",
                          align: "center",
                        },
                      ],

                      rows: [
                        {
                          photo: (
                            <MKBox maxWidth={300}>
                              <MKAvatar
                                src={
                                  overallValues?.personalDetails?.profile_image
                                }
                                name={overallValues?.personalDetails?.name}
                                size="md"
                              />
                            </MKBox>
                          ),
                          name: (
                            <MKTypography
                              variant="caption"
                              color="text"
                              fontWeight="medium"
                            >
                              {overallValues?.personalDetails?.name}
                            </MKTypography>
                          ),
                          email: (
                            <MKTypography
                              variant="caption"
                              color="text"
                              fontWeight="medium"
                            >
                              {overallValues?.personalDetails?.email}
                            </MKTypography>
                          ),
                          phone: (
                            <MKTypography
                              variant="caption"
                              color="text"
                              fontWeight="medium"
                            >
                              {overallValues?.personalDetails?.phone}
                            </MKTypography>
                          ),
                        },
                      ],
                    }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                </MKBox>

                <Grid container spacing={3} px={3}>
                  <Grid item xs={12} md={6} lg={6} sx={{ p: 1 }}>
                    <MKTypography variant="h6">
                      Original Chosen Policy
                    </MKTypography>
                  </Grid>
                </Grid>
                <MKBox p={3} mb={5}>
                  <DataTable
                    table={{
                      columns: [
                        {
                          Header: "Description",
                          accessor: "description",
                          width: "30%",
                          align: "left",
                        },
                        {
                          Header: "Insured Items",
                          accessor: "insuredItems",
                          width: "30%",
                          align: "left",
                        },

                        {
                          Header: "Premium Amount",
                          accessor: "premiumAmount",
                          width: "20%",
                          align: "center",
                        },
                        {
                          Header: "Active",
                          accessor: "active",
                          width: "10%",
                          align: "center",
                        },
                      ],

                      rows: [
                        {
                          description: (
                            <MKBox maxWidth={300}>
                              <MKTypography
                                variant="caption"
                                color="text"
                                fontWeight="medium"
                              >
                                {overallValues?.policy?.description}
                              </MKTypography>
                            </MKBox>
                          ),
                          insuredItems: (
                            <MKBox display="flex" flexDirection="column">
                              {overallValues?.policy?.insuredItems?.map(
                                (item, index) => (
                                  <MKTypography
                                    key={index}
                                    variant="caption"
                                    color="text"
                                    fontWeight="medium"
                                    mb={1}
                                  >
                                    ({index + 1}) {item}
                                  </MKTypography>
                                )
                              )}
                            </MKBox>
                          ),
                          premiumAmount: (
                            <MKTypography
                              variant="caption"
                              color="text"
                              fontWeight="medium"
                            >
                              Ksh. {overallValues?.policy?.premiumAmount}
                            </MKTypography>
                          ),
                          active: (
                            <MKTypography
                              variant="caption"
                              color="text"
                              fontWeight="medium"
                            >
                              {overallValues?.policy?.active ? (
                                <MKBox ml={-1}>
                                  <MKBadge
                                    badgeContent="active"
                                    color="dark"
                                    variant="gradient"
                                    size="sm"
                                  />
                                </MKBox>
                              ) : (
                                <MKBox ml={-1}>
                                  <MKBadge
                                    badgeContent="inactive"
                                    color="success"
                                    variant="gradient"
                                    size="sm"
                                  />
                                </MKBox>
                              )}
                            </MKTypography>
                          ),
                        },
                      ],
                    }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                </MKBox>

                <Grid container spacing={3} px={3}>
                  <Grid item xs={12} md={6} lg={6} sx={{ p: 1 }}>
                    <MKTypography variant="h6">Claim Description</MKTypography>
                  </Grid>
                </Grid>
                <MKBox mx={5} mt={3} mb={8}>
                  <MKTypography
                    variant="body"
                    fontSize="medium"
                    color="text"
                    fontWeight="regular"
                    mt={1}
                  >
                    {overallValues?.description} hmm
                  </MKTypography>
                </MKBox>

                <Grid container spacing={3} px={3}>
                  <Grid item xs={12} md={6} lg={6} sx={{ p: 1 }}>
                    <MKTypography variant="h6">
                      Requirements Provided
                    </MKTypography>
                  </Grid>
                </Grid>
                <MKBox p={3} mb={5}>
                  <DataTable
                    table={{
                      columns: [
                        {
                          Header: "Requested Item",
                          accessor: "requestedItem",
                          width: "30%",
                          align: "left",
                        },
                        {
                          Header: "Description",
                          accessor: "description",
                          width: "30%",
                          align: "left",
                        },
                        {
                          Header: "Type",
                          accessor: "type",
                          width: "20%",
                          align: "center",
                        },
                        {
                          Header: "Your Response",
                          accessor: "response",
                          width: "20%",
                          align: "center",
                        },
                      ],

                      rows: renderRequirementsRows(overallValues?.requirements),
                    }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                </MKBox>
              </MKBox>
            </Card>
          </Grid>
        </Grid>
      </MKBox>
      <Grid
        container
        spacing={0}
        direction="row"
        justifyContent="space-between"
      >
        <Grid item md={1} lg={1}>
          <MKButton
            disabled={isSubmitting}
            onClick={(e) => props.back(e, props?.values)}
          >
            Back
          </MKButton>
        </Grid>
        <Grid item md={7} lg={7} />
        <Grid item md={2} lg={2}>
          <MKButton disabled={success} onClick={handleSubmitClaim}>
            Initiate Your Claim
          </MKButton>
        </Grid>
        <Grid item md={1} lg={1}>
          <MKButton
            disabled={
              isSubmitting ||
              !claimsPost ||
              claimsPost === undefined ||
              error ||
              !success
            }
            onClick={(e) => handleSubmit(e)}
          >
            Submit
          </MKButton>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default ClaimReviewStep;
